import React from "react"
import CustomAutocomplete, { CustomAutocompleteProps } from "./CustomAutocomplete"
import { Language } from "src/utils/useLanguageList"

interface Props extends Omit<CustomAutocompleteProps<Language>, "getOptionLabel"> {
  label: string
  hint?: string
  hideLabel?: boolean
  options: Language[]
}

const LanguageSelect = ({ label, value, disabled, onChange, multiple, hint, hideLabel, options }: Props) => {
  return (
    <CustomAutocomplete
      multiple={multiple}
      value={value}
      label={hideLabel ? "" : label}
      options={options}
      disabled={disabled}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option?.languageId === value?.languageId}
      onChange={onChange}
      helperText={hint}
      disableClearable={!multiple}
    />
  )
}

export default LanguageSelect
